import React from 'react';
import { WebsitesHero } from '../components/websites/WebsitesHero';
import { ProofStrip } from '../components/websites/ProofStrip';
import { OldVsLiving } from '../components/websites/OldVsLiving';
import { HowItWorks } from '../components/websites/HowItWorks';
import { KeepYourWebsite } from '../components/websites/KeepYourWebsite';
import { ChangeChannels } from '../components/websites/ChangeChannels';
import { InsideDash } from '../components/websites/InsideDash';
import { FreeGuide } from '../components/websites/FreeGuide';
import { WhatsIncluded } from '../components/websites/WhatsIncluded';
import { PickYourPhotos } from '../components/websites/PickYourPhotos';
import { WebsiteFeatures } from '../components/websites/WebsiteFeatures';
import { FullSystem } from '../components/websites/FullSystem';
import { FeelAlive } from '../components/websites/FeelAlive';
import { ThreeDayBuild } from '../components/websites/ThreeDayBuild';
import { RealSites } from '../components/websites/RealSites';
import { TryItNow } from '../components/websites/TryItNow';
import { TwoWaysToStart } from '../components/websites/TwoWaysToStart';
import { ComingSoon } from '../components/websites/ComingSoon';
import { WebsitesFinalCta } from '../components/websites/WebsitesFinalCta';
import { ExploreMore } from '../components/websites/ExploreMore';
import { ServiceFaq } from '../components/ServiceFaq';
import { websitesPageFaqs } from '../data/faqs';
export function Websites() {
  return <>
      <WebsitesHero data-id="element-1224" data-mp="2dgjh3ae3ici9" />
      <ProofStrip data-id="element-1225" data-mp="2dgt5wunemdmd" />
      <OldVsLiving data-id="element-1226" data-mp="2dhbbihvyi46y" />
      <HowItWorks data-id="element-1227" data-mp="2dhuix4nzda6q" />
      <KeepYourWebsite data-id="element-1228" data-mp="2dicoirwj90rb" />
      <ChangeChannels data-id="element-1229" data-mp="1ys5e8zgoio1p" />
      <InsideDash data-id="element-1230" data-mp="1ysojpgp57jyu" />
      <FreeGuide data-id="element-1231" data-mp="1yt84r6a3aoh3" />
      <WhatsIncluded data-id="element-1232" data-mp="1ypkb874na22d" />
      <PickYourPhotos data-id="element-1233" data-mp="23qgo3a6z4yjx" />
      <WebsiteFeatures data-id="element-1234" data-mp="23pykttlw9k2i" />
      <FullSystem data-id="element-1235" data-mp="23r9l3jg4s9ov" />
      <FeelAlive data-id="element-1236" data-mp="23onfhpcsw49a" />
      <ThreeDayBuild data-id="element-1237" data-mp="1pqytge6zyr2n" />
      <RealSites data-id="element-1238" data-mp="1pqfdh30wqcr9" />
      <TryItNow data-id="element-1239" data-mp="1ps06upbhjpnj" />
      <TwoWaysToStart data-id="element-1240" data-mp="1prgy9z7q6dm6" />
      <ComingSoon data-id="element-1241" data-mp="1ptb8ojldenc0" />
      <ServiceFaq serviceName="Living Websites" faqs={websitesPageFaqs} showContact={false} data-id="element-1242" data-mp="1ups9oedo4w6i" />
      <WebsitesFinalCta data-id="element-1243" data-mp="9tiwv9gy458" />
      <ExploreMore data-id="element-1244" data-mp="a38ihqlq9ae" />
    </>;
}